export interface BookingStatusConfig {
  name: string;
  icon: string;
  color: string;
  bgColor: string;
}

export const BOOKING_STATUS_CONFIG: Record<string, BookingStatusConfig> = {
  total_bob: {
    name: 'Total Business on Books',
    icon: 'fa fa-exclamation-circle text-info',
    color: '#2196F3',
    bgColor: '#E3F2FD'
  },
  confirmed_bob: {
    name: 'Confirmed BoB',
    icon: 'fa fa-check-circle text-success',
    color: '#4CAF50',
    bgColor: '#E8F5E8'
  },
  tentative_bob: {
    name: 'Tentative BoB',
    icon: 'fa fa-clock-o text-warning',
    color: '#FF9800',
    bgColor: '#FFF3E0'
  },
  waitlisted_bob: {
    name: 'Waitlisted BoB',
    icon: 'fa fa-exclamation-circle text-info',
    color: '#2196F3',
    bgColor: '#E3F2FD'
  },
  confirmed: {
    name: 'Confirmed',
    icon: 'fa fa-check-circle text-success',
    color: '#4CAF50',
    bgColor: '#E8F5E8'
  },
  tentative: {
    name: 'Tentative',
    icon: 'fa fa-clock-o text-warning',
    color: '#FF9800',
    bgColor: '#FFF3E0'
  },
  waitlisted: {
    name: 'Waitlisted',
    icon: 'fa fa-exclamation-circle text-info',
    color: '#2196F3',
    bgColor: '#E3F2FD'
  },
  cancelled: {
    name: 'Cancelled',
    icon: 'fa fa-times-circle-o text-danger',
    color: '#F44336',
    bgColor: '#FFEBEE'
  },
  rfq: {
    name: 'RFQ',
    icon: 'fa fa-question-circle text-secondary',
    color: '#fb8c00',
    bgColor: '#FFF3E0'
  },
  complementary: {
    name: 'Complementary',
    icon: 'fa fa-check-circle-o text-muted',
    color: '#00838f',
    bgColor: '#e0f7fa'
  }
};

export const getBookingStatusConfig = (status: string): BookingStatusConfig => {
  return BOOKING_STATUS_CONFIG[status?.toLowerCase()] || BOOKING_STATUS_CONFIG.confirmed;
};

export const getBookingStatusIcon = (status: string): string => {
  return getBookingStatusConfig(status).icon;
};

export const getBookingStatusColor = (status: string): string => {
  return getBookingStatusConfig(status).color;
};

export const getBookingStatusBgColor = (status: string): string => {
  return getBookingStatusConfig(status).bgColor;
};
